const courseCf7 = () => {
  const popupWrapper = document.querySelector('#popup-wrapper[data-course-form="true"]');
  if (!popupWrapper) return;

  // Populate offline course name
  const setCourseName = () => {
    const titleEl = document.querySelector('h1.product-page__title');
    if (!titleEl) return;

    const courseTitle = titleEl.textContent.trim();
    if (!courseTitle) return;

    const hiddenInput = specialForm.querySelector('input[name="course_name"]');
    if (!hiddenInput) return;

    hiddenInput.value = courseTitle;
  };

  popupWrapper.addEventListener('transitionend', setCourseName);

  // Popup
  const popupClose = document.getElementById('popup-close');
  const popupCloseBtn = document.querySelector('.btn-close-popup');
  const body = document.body;

  const specialForm = popupWrapper.querySelector('form.wpcf7-form, form');
  if (!specialForm) return;

  const resetSelect = (select) => {
    if (!select || !select.options || !select.options.length) return;

    select.selectedIndex = 0;

    if (window.jQuery && jQuery(select).hasClass('select-2')) {
      jQuery(select).val(select.options[0].value).trigger('change');
    } else {
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const resetForm = () => {
    specialForm.reset();

    const responseOutput = specialForm.querySelector('.wpcf7-response-output');
    if (responseOutput) {
      responseOutput.innerHTML = '';
      responseOutput.style.display = 'none';
    }

    resetSelect(
      specialForm.querySelector('#offline_course_region'),
    );

    resetSelect(
      specialForm.querySelector('#offline_course_city'),
    );

    specialForm
      .querySelectorAll('.wpcf7-not-valid')
      .forEach(el => el.classList.remove('wpcf7-not-valid'));

    specialForm
      .querySelectorAll('.wpcf7-not-valid-tip')
      .forEach(el => el.remove());
  };

  const getFormId = (form) => {
    if (form.dataset && form.dataset.wpcf7Id) return String(form.dataset.wpcf7Id);

    const hidden = form.querySelector('input[name="_wpcf7"]');
    if (hidden && hidden.value) return String(hidden.value);

    const idAttr = form.getAttribute('id') || '';
    const match = idAttr.match(/wpcf7\-f(\d+)/);
    if (match && match[1]) return String(match[1]);

    return null;
  };

  const allowedFormId = getFormId(specialForm);
  if (!allowedFormId) return;

  document.addEventListener('wpcf7mailsent', (event) => {
    const eventFormId = String(event?.detail?.contactFormId ?? '');
    if (!eventFormId || eventFormId !== allowedFormId) return;

    resetForm();

    const messageBox = specialForm.querySelector('.wpcf7-response-output');
    if (messageBox) messageBox.style.display = 'none';

    popupWrapper.style.display = 'none';
    popupWrapper.classList.remove('active');
    body.style.overflow = 'auto';

    const successModal = document.getElementById('success-modal');
    const successClose = document.getElementById('success-close');

    if (successModal) {
      successModal.classList.add('active');
    }

    if (successClose) {
      successClose.addEventListener('click', () => {
        successModal.classList.remove('active');
        body.style.overflow = 'auto';
      }, { once: true });
    }
  }, false);

  if (popupClose) {
    popupClose.addEventListener('click', () => {
      popupWrapper.style.display = 'none';
      popupWrapper.classList.remove('active');
      body.style.overflow = 'auto';
      resetForm();
    });
  }

  if (popupCloseBtn) {
    popupCloseBtn.addEventListener('click', () => {
      popupWrapper.style.display = 'none';
      popupWrapper.classList.remove('active');
      body.style.overflow = 'auto';
      resetForm();
    });
  }
};

export default courseCf7;
